<div class="row">
  <div class="col-lg-12">
    <div class="form-group">
      <div class="d-flex justify-content-between align-items-center">
        <label [ngClass]="{'required-label': isRequired}" class="control-label">{{ ('lookups.' + type + 's.label_' + (multiple ? 'plural' : 'singular')) | translate }}</label>
        <button (click)="openLookupOptionsModal()"
                *ngIf="canEdit"
                class="btn btn-link p-0 mb-2"
                type="button">{{ 'lookups.settings' | translate }}
        </button>
      </div>
      
      <ng-select [clearable]="false"
                 [closeOnSelect]="!multiple"
                 [formControl]="formControl"
                 [items]="options$ | async"
                 [loading]="loading"
                 [multiple]="multiple"
                 bindLabel="label"
                 bindValue="key"
                 class="custom"
      ></ng-select>
      
      <div *ngIf="submitted && formGroup.controls?.[controlName]?.errors">
        <p
            *ngIf="formGroup.controls?.[controlName]?.errors?.required"
            class="text-danger validation-text"
        >
          <span>{{ 'angular_validation.field' | translate }} </span>
          <span>{{ ('lookups.' + type + 's.label_' + (multiple ? 'plural' : 'singular')) | translate }} </span>
          <span>{{ 'angular_validation.required' | translate }}</span>
        </p>
      </div>
    </div>
  </div>
</div>
